import { createSlice } from "@reduxjs/toolkit";

const initialHomeworkSource = {
  name: "",
  pageNumber: 1
}

const initialHomeworkSourcesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courses: [],
  homeworkSource: initialHomeworkSource
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const homeworkSourceSlice = createSlice({
  name: "homeworkSources",
  initialState: initialHomeworkSourcesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHomeworkSources
    homeworkSourcesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getGradeCourses
    coursesFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.courses =  action.payload.entities;
    },
    // getHomeworkSource
    homeworkSourceFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.homeworkSource = action.payload.entity;
      state.courses = action.payload.entity && action.payload.entity.courses;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanCourses
    coursesCleaned: (state) => {
      state.courses = [];
    },
    // cleanHomeworkSourcesState
    homeworkSourcesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.homeworkSource = initialHomeworkSource;
    }
  }
});